<template>
  <v-card id="signin_review__vista__card" outlined>
    <v-card-title>Nombre de Archivo</v-card-title>
    <v-card-subtitle>
      <div>{{ reviewFileName }}</div>
    </v-card-subtitle>

    <v-divider inset></v-divider>
    <v-card-title>Longitud</v-card-title>
    <v-card-subtitle>
      <div>{{ reviewFileSize }}</div>
    </v-card-subtitle>

    <v-divider inset></v-divider>
    <v-card-title>Hash</v-card-title>
    <v-card-subtitle>
      <div>{{ reviewHash }}</div>
    </v-card-subtitle>

    <v-divider inset></v-divider>
    <v-card-title>Razón Social</v-card-title>
    <v-card-subtitle>
      <div>{{ reviewRazonSocial }}</div>
    </v-card-subtitle>

    <v-divider inset></v-divider>
    <v-card-title>RFC</v-card-title>
    <v-card-subtitle>
      <div>{{ reviewRFC }}</div>
    </v-card-subtitle>
  </v-card>
</template>

<script>
import {
  signingReviewData,
  signingReviewActions
} from '@/modules/signers/store/signingReviewStoreHelpers'

export default {
  name: 'SigningReview',
  computed:{
    ...signingReviewData
  },
  methods:{
    ...signingReviewActions
  }
}
</script>

<style scoped>
.v-card__subtitle{
  padding-bottom: 10px!important;
}
</style>